import { BaseEntity } from "./base-entity";

export class LoginInfoEntity extends BaseEntity{

    public createtime:string|undefined;
    public department:string|undefined;
    public id:number|undefined;
    public state:number|undefined;
    public telephone:string|undefined;
    public useraccount:string|undefined;
    public username:string|undefined;
    public key:string|undefined;
    public password:string|undefined;
    public menuList: any;
    public isAdmin:number = 0; // 是否是管理员  1 是 0 不是
    public selectMenuKey:string = ""
}